module.exports = __webpack_public_path__ + "static/media/minus-black-o.561f3bd2.svg";